<template>
  <div class="CartIcon h-24">
    <button
      class="relative flex gap-8 items-center cursor-pointer"
      type="button"
      :aria-label="accessibleLabel"
      @click="openCart"
      @mouseenter="sendDebounce"
    >
      <!-- Visual only - the button is named by :aria-label so the count never
           concatenates into the accessible name (e.g. "3Varukorg") -->
      <div
        class="relative"
        aria-hidden="true"
        :class="{
          favoriteAnimateIn: showAnimation
        }"
      >
        <img
          src="/icons/cart.svg"
          class="w-24 h-24"
          alt=""
        >
        <div
          v-if="cartStore.isLoading"
          class="absolute top-8 left-6"
        >
          <img
            src="/icons/spinner.svg"
            class="h-12 w-12 spin"
            alt=""
          >
        </div>
        <div
          v-else-if="cartItems > 0"
          class="flex items-center justify-center w-20 h-20
          absolute -top-8 -left-[8px]
          bg-bg-errorStrong text-text-inverse type-headline-xs rounded-full"
        >
          {{ cartItems }}
        </div>
      </div>
      <div
        class="mobOnly:hidden py-2 whitespace-nowrap overflow-hidden overflow-ellipsis"
        aria-hidden="true"
      >
        {{ $t('header.cart') }}
      </div>
    </button>
    <!-- Announces later changes to the count; kept outside the button so it is
         not part of the button's accessible name -->
    <span
      class="sr-only"
      aria-live="polite"
      aria-atomic="true"
    >
      {{ cartItems > 0 ? $t('wcag.cartItems', { count: cartItems }) : '' }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import { useCartStore } from '~/store/cart';
import { storeToRefs } from 'pinia';
const uiStore = useUiStore();

const cartStore = useCartStore();

const { cartItems } = storeToRefs(cartStore);

const { $t } = useNuxtApp();

// Names the button on focus: "Varukorg" when empty, "3 varor i varukorg" otherwise.
const accessibleLabel = computed(() => {
  return cartItems.value > 0
    ? $t('wcag.cartItems', { count: cartItems.value })
    : $t('header.cart');
});

const openCart = () => {
  cartStore.sendDebouncedQueue();
  uiStore.setShowMiniCart(true);
};

const sendDebounce = () => {
  cartStore.sendDebouncedQueue();
};

const showAnimation = ref(false);
watch(cartItems, (newVal, oldVal)=> {
  if (newVal > oldVal) {
    showAnimation.value = true;
    setTimeout(()=> showAnimation.value = false, 2000);
  }
});

</script>
